import { render, staticRenderFns } from "./three-D.vue?vue&type=template&id=705f8d16&scoped=true"
import script from "./three-D.vue?vue&type=script&lang=js"
export * from "./three-D.vue?vue&type=script&lang=js"
import style0 from "./three-D.vue?vue&type=style&index=0&id=705f8d16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705f8d16",
  null
  
)

export default component.exports